import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useAppSelector } from 'hooks/typedReduxHooks';
import useCustomSearchParams from 'hooks/useCustomSearchParams';
import useSearchRules from 'hooks/useSearchRules';

const Rules = () => {
  const { status, errorStatus, rules } = useAppSelector(((state) => state.rules));
  const { getRules } = useSearchRules();

  const [searchParams] = useCustomSearchParams();

  useEffect(() => {
    if (!status && !rules?.length) {
      getRules(searchParams);
    }

    if (status === 'rejected' && errorStatus === 401) {
      const url = new URLSearchParams();
      url.set('redirect', window.location.pathname + window.location.search);
      window.location.href = `/login?${url.toString()}`;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, status, rules?.length]);

  return <Outlet />;
};

export default Rules;
